import { SaleItemInterface } from '../../../../../common/types/interfaces'
import { ListItem } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: SaleItemInterface) => void
  startDuplicate: (el: SaleItemInterface) => void
  showDetails: (el: SaleItemInterface) => void
  list: SaleItemInterface[]
  loading?: boolean
}

export const List = ({ startEdit, startDuplicate, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет товаров</div>
      ) : (
        list.map((el) => (
          <ListItem
            el={el}
            startEdit={startEdit}
            startDuplicate={startDuplicate}
            key={el.id}
            showDetails={showDetails}
          />
        ))
      )}
    </div>
  )
}
